import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import { Box, Dialog, DialogActions, DialogContent } from "@mui/material";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import React from "react";
import { ButtonCompo } from "../../../components/Comman/Button";
import TypographyCompo from "../../../components/Comman/TypographyCompo";
import { primaryActionButtonSx } from "../styles/advanceOutletInvoicingStyles";
import BootstrapDialogTitle from "./BootstrapDialogTitle";

const BootstrapDialog = styled(Dialog)(() => ({}));

const OfferSelectionDialog = ({
	open,
	onClose,
	checkboxAllData,
	onSubmit,
	renderOfferCheckbox,
}) => (
	<BootstrapDialog
		onClose={onClose}
		aria-labelledby="offer-dialog-title"
		open={open}
		className="offer-dialog"
		fullWidth
		maxWidth="md"
	>
		<BootstrapDialogTitle
			id="offer-dialog-title"
			onClose={onClose}
			sx={{ p: 0 }}
		>
			<Box className="offer-dialog-header">
				<Box className="offer-dialog-header-icon">
					<LocalOfferOutlinedIcon />
				</Box>
				<Box>
					<TypographyCompo className="offer-dialog-title-text">
						Applicable Offers
					</TypographyCompo>
					<TypographyCompo className="offer-dialog-subtitle">
						Select offers to apply on this bill
					</TypographyCompo>
				</Box>
			</Box>
		</BootstrapDialogTitle>

		<DialogContent>
			<Box className="offer-dialog-body">
				{checkboxAllData.length === 0 ? (
					<TypographyCompo className="offer-dialog-empty">
						No applicable offers available for this bill.
					</TypographyCompo>
				) : (
					<div className="offer-dialog-grid">
						{renderOfferCheckbox(0, 0)}
						{renderOfferCheckbox(1, 0)}
						{renderOfferCheckbox(0, 1)}
						{renderOfferCheckbox(1, 1)}
					</div>
				)}
			</Box>
		</DialogContent>

		<DialogActions sx={{ p: 0 }}>
			<Box className="offer-dialog-footer">
				<ButtonCompo
					sx={primaryActionButtonSx}
					size="medium"
					type="button"
					variant="contained"
					name="Submit"
					onClick={onSubmit}
					fullWidth={false}
				/>
			</Box>
		</DialogActions>
	</BootstrapDialog>
);

OfferSelectionDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	checkboxAllData: PropTypes.array.isRequired,
	onSubmit: PropTypes.func.isRequired,
	renderOfferCheckbox: PropTypes.func.isRequired,
};

export default OfferSelectionDialog;
